import * as React from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import MuiToolbar from '@mui/material/Toolbar';
import { tabsClasses } from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SideMenuMobile from './SideMenuMobile';
import MenuButton from './MenuButton';
import ColorModeIconDropdown from '../../shared-theme/ColorModeIconDropdown';
import SvgIcon from '@mui/material/SvgIcon';

const Toolbar = styled(MuiToolbar)({
  width: '100%',
  padding: '12px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'center',
  gap: '12px',
  flexShrink: 0,
  [`& ${tabsClasses.flexContainer}`]: {
    gap: '8px',
    p: '8px',
    pb: 0,
  },
});

export default function AppNavbar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        display: { xs: 'auto', md: 'none' },
        boxShadow: 0,
        bgcolor: 'background.paper',
        backgroundImage: 'none',
        borderBottom: '1px solid',
        borderColor: 'divider',
        top: 'var(--template-frame-height, 0px)',
      }}
    >
      <Toolbar variant="regular">
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            flexGrow: 1,
            width: '100%',
            gap: 1,
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            sx={{ justifyContent: 'center', mr: 'auto', whiteSpace: 'nowrap', overflow: 'hidden' }}
          >
            <CustomIcon />
            <Typography variant="h4" component="h1" sx={{ color: 'text.primary', textOverflow: 'ellipsis', overflow: 'hidden' }}>
              MILLET Mobility
            </Typography>
          </Stack>
          <ColorModeIconDropdown data-screenshot="" />
          <MenuButton aria-label="menu" onClick={toggleDrawer(true)}>
            <MenuRoundedIcon />
          </MenuButton>
          <SideMenuMobile open={open} toggleDrawer={toggleDrawer} />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

export function CustomIcon() {
  return (
    <Box
      sx={{
        width: '1.5rem',
        height: '1.5rem',
        bgcolor: '#FECB3A',
        borderRadius: '999px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
      }}
    >
      <SvgIcon>
        <svg id="MILLET" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
          <g id="Logo">
            <path className="cls-1" d="M363.98,227.48c.19,4.23.45,7.28.45,10.32,0,145.01-.17,290.03.21,435.04.03,11.91-3.37,19.83-12.48,27.56-35.2,29.89-69.59,60.74-104.61,90.85-3.93,3.38-9.96,4.32-15.01,6.4-1.83-5.15-5.22-10.3-5.25-15.47-.36-62.47-.23-124.93-.22-187.4,0-78.72.12-157.45-.14-236.17-.03-9.09,2.76-15.55,9.64-21.5,40.73-35.19,81.17-70.72,121.74-106.1,1.32-1.15,2.99-1.89,5.67-3.54Z" />
            <path className="cls-1" d="M660.01,226.67c6.6,5.6,12.12,10.16,17.51,14.87,36.69,32.04,73.27,64.2,110.1,96.07,6.57,5.68,9.46,11.98,9.45,20.69-.16,140.15-.1,280.3-.1,420.45,0,.64.17,1.34-.03,1.9-2.07,5.64-4.21,11.25-6.33,16.88-5.21-2.41-11.31-3.8-15.48-7.4-36.88-31.81-73.5-63.93-109.9-96.28-3.05-2.71-5.57-7.84-5.58-11.85-.29-148.75-.26-297.51-.24-446.26,0-2.43.31-4.85.6-9.07Z" />
            <path className="cls-1" d="M500.28,788.51c-5.22-4.41-9.05-7.55-12.78-10.8-31.21-27.21-62.32-54.54-93.7-81.56-5.51-4.74-7.96-9.57-7.95-17.06.23-147.56.17-295.11.19-442.67,0-2.71.33-5.41.63-10.07,11.12,9.59,20.92,17.99,30.66,26.47,25.7,22.38,51.27,44.9,77.13,67.1,4.81,4.13,6.57,8.45,6.57,14.74-.15,147.88-.1,295.75-.11,443.63,0,2.71-.33,5.43-.64,10.23Z" />
            <path className="cls-1" d="M523.1,789.11c0-6.37,0-9.79,0-13.22-.02-147.55-.07-295.09.14-442.64,0-3.92,1.71-9.1,4.5-11.57,34.82-30.81,69.99-61.23,105.1-91.73.68-.59,1.63-.87,3.68-1.93.3,3.17.77,5.75.77,8.33.05,148.5.09,297.01-.06,445.51,0,3.44-1.06,8.07-3.4,10.15-35.93,31.86-72.16,63.39-110.74,97.1Z" />
          </g>
        </svg>
      </SvgIcon>
    </Box>
  );
}
